import React from 'react';
import {connect} from 'react-redux';
import {selectCurrentUserTeams, selectCurrentUserPermissions} from 'ducks/auth';
import {hasEntityPermissionOrAnyTeamOwnership} from 'utils/permissions';

class VisibleIfAnyTeamOwner extends React.Component<any> {
  render() {
    const {
      not,
      permission,
      userTeams,
      userPermissions,
      locationRef,
      children
    } = this.props;
    const teamsThatIOwn = userTeams.filter(team => team.isOwner);
    const hasPermission = hasEntityPermissionOrAnyTeamOwnership({
      userPermissions,
      permission,
      locationRef,
      teamsThatIOwn
    });

    // user has no permission and "not" is false
    if (!hasPermission && !not) {
      return null;
    }

    // user has permission but "not" is true
    if (hasPermission && !!not) {
      return null;
    }

    return children;
  }
}

const mapStateToProps = state => ({
  userTeams: selectCurrentUserTeams(state),
  userPermissions: selectCurrentUserPermissions(state)
});

export default connect(mapStateToProps)(VisibleIfAnyTeamOwner);
